import axios from 'src/shared/utils/axios';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import i18n from 'i18next';
import { addToast } from '../toasts/toastsActions';

export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGIN_AS = 'SESSION_LOGIN_AS';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const CLEAN_STORE = 'CLEAN_STORE';

const loginEndpoint = (endpointByUserRole, otp = '') =>
  `${process.env.REACT_APP_ZEUS_API_URL}${endpointByUserRole}${otp}`;

export const login = (email, token, role) => ({
  type: SESSION_LOGIN,
  email,
  role
});

export const loginAs = token => ({
  type: SESSION_LOGIN_AS
});

export const logout = () => ({
  type: SESSION_LOGOUT
});

export const cleanStore = () => ({
  type: CLEAN_STORE
});

export const loginAsAdmin =
  (payload, userRole, loginByUserRole, firstStep = true) =>
  async dispatch => {
    try {
      const response = await axios.post(loginEndpoint(loginByUserRole, payload?.otp ? '/otp' : ''), payload);

      if (response.data?.otpCreatedAt) {
        return response.data;
      }

      dispatch(cleanStore());
      dispatch(login(payload.email, response.data?.jwt, userRole));

      return response.data;
    } catch (error) {
      const status = error.response?.status;
      const errorCode = error.response?.data?.code;
      let message;

      if (status === 401) {
        message = i18n.t('session.login.invalid credentials', {
          ns: ['actions']
        });

        if (!firstStep) {
          return null;
        }
      } else if (status === 429) {
        message = i18n.t('session.login.please try again later', {
          ns: ['actions']
        });
      } else if (status === 403) {
        if (errorCode === 'PASSWORD_EXPIRED') {
          return { passwordExpired: true };
        } else if (errorCode === 'ACCOUNT_LOCKED') {
          const lockedUntilIso = error.response.data.lockedUntil;

          const lockedUntil = new Date(lockedUntilIso);
          const now = new Date();

          const diffMs = lockedUntil - now;
          const totalSeconds = Math.floor(diffMs / 1000);

          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          const pad = n => String(n).padStart(2, '0');
          message = i18n.t(
            'session.login.Account is temporarily locked due to too many failed login attempts. Please try again later.',
            {
              ns: ['actions'],
              time: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
            }
          );
        }
      }

      dispatch(addToast({ ...toastTypes.error, defaultMessage: message }, error));

      if (status === 401 && firstStep) {
        return { invalidCredentials: true };
      }

      return null;
    }
  };
